<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { setCookie } from "@/utils/index";

export default {
  name: "App",
  components: {},
  mounted() {},
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: #FAFBFF;
}
</style>
